"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Feb 18 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var PromotionSimulation_1 = require("../model/PromotionSimulation");

var PromotionSimulationConverter_1 = require("./PromotionSimulationConverter");
/**
 * @author BPo
 */


var PromotionSimulationConverterImpl =
/*#__PURE__*/
function (_PromotionSimulationC) {
  _inherits(PromotionSimulationConverterImpl, _PromotionSimulationC);

  function PromotionSimulationConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, PromotionSimulationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionSimulationConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }

  _createClass(PromotionSimulationConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromotionSimulation_1.PromotionSimulation(PromotionSimulation_1.PromotionSimulation.schema.id.valueOf(conversions.documentToClassId(source)), PromotionSimulation_1.PromotionSimulation.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), PromotionSimulation_1.PromotionSimulation.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), PromotionSimulation_1.PromotionSimulation.schema.lastModified.valueOfField(source), this.userInfoConverter.toObject(source.lastModifiedBy, conversions));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        lastModified: conversions.fromDate(source.lastModified),
        lastModifiedBy: this.userInfoConverter.toDocument(source.lastModifiedBy, conversions)
      });
      return result;
    }
  }]);

  return PromotionSimulationConverterImpl;
}(PromotionSimulationConverter_1.PromotionSimulationConverter);

PromotionSimulationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], PromotionSimulationConverterImpl);
exports.PromotionSimulationConverterImpl = PromotionSimulationConverterImpl;